// import swag

export const GOOGLE_ICON_NAMES = [
  'circle',
  'do_not_disturb_on_total_silence',
  'drag_handle',
  'flag_2',
  'priority_high',
  'public',
  'sell',
  'square',
  'star',
  'star_border',
  'stat_1',
  'stat_2',
  'stat_3',
  'stat_minus_1',
  'stat_minus_2',
  'stat_minus_3',
  'warning',
]

export const GOOGLE_ICON_OPTIONS = {
  'star_filled': { id: 'star_filled', name: 'Star filled', icon: 'star', filled: true },
  'star_unfilled': { id: 'star_unfilled', name: 'Star', icon: 'star', filled: false },
  'flag_2_filled': { id: 'flag_2_filled', name: 'Flag 2 filled', icon: 'flag_2', filled: true },
  'square_filled': { id: 'square_filled', name: 'Square filled', icon: 'square', filled: true },
  'square_unfilled': { id: 'square_unfilled', name: 'Square', icon: 'square', filled: false },
  'circle_filled': { id: 'circle_filled', name: 'Circle filled', icon: 'circle', filled: true },
  'circle_unfilled': { id: 'circle_unfilled', name: 'Circle', icon: 'circle', filled: false },
  'warning_unfilled': { id: 'warning_unfilled', name: 'Warning', icon: 'warning', filled: false },
  'do_not_disturb_on_total_silence_unfilled': { id: 'do_not_disturb_on_total_silence_unfilled', name: 'Do not disturb', icon: 'do_not_disturb_on_total_silence', filled: false },
  'priority_high_unfilled': { id: 'priority_high_unfilled', name: 'Priority high', icon: 'priority_high', filled: false },
  'stat_3_unfilled': { id: 'stat_3_unfilled', name: 'Stat 3', icon: 'stat_3', filled: false },
  'stat_2_unfilled': { id: 'stat_2_unfilled', name: 'Stat 2', icon: 'stat_2', filled: false },
  'stat_1_unfilled': { id: 'stat_1_unfilled', name: 'Stat 1', icon: 'stat_1', filled: false },
  'drag_handle_unfilled': { id: 'drag_handle_unfilled', name: 'Drag handle', icon: 'drag_handle', filled: false },
  'stat_minus_1_unfilled': { id: 'stat_minus_1_unfilled', name: 'Stat minus 1', icon: 'stat_minus_1', filled: false },
  'stat_minus_2_unfilled': { id: 'stat_minus_2_unfilled', name: 'Stat minus 2', icon: 'stat_minus_2', filled: false },
  'stat_minus_3_unfilled': { id: 'stat_minus_3_unfilled', name: 'Stat minus 3', icon: 'stat_minus_3', filled: false },
}

export const validateGoogleIconName = (value) => {
  if (!GOOGLE_ICON_NAMES.includes(value)) {
    throw new Error(
      `"${value}" is not in the CDN icon_names list. ` +
      `Add it to index.html and GOOGLE_ICON_NAMES. ` +
      `index.html icon_names MUST be in alphabetical order`
    )
  }
  return true
}
